/**
 * Warwick Design System - Spacing Tokens
 * Consistent spacing system based on design specifications
 * All sizes converted from pixels to rem (16px = 1rem)
 */

// Base spacing scale
export const spacing = {
  // Micro spacing
  xs: '0.25rem',    // 4px
  sm: '0.5rem',     // 8px
  md: '0.75rem',    // 12px
  
  // Standard spacing
  base: '1rem',     // 16px
  lg: '1.25rem',    // 20px
  xl: '1.5rem',     // 24px
  '2xl': '2rem',    // 32px
  '3xl': '2.5rem',  // 40px
  
  // Large spacing
  '4xl': '3rem',    // 48px
  '5xl': '4rem',    // 64px
  '6xl': '5rem',    // 80px
  '8xl': '8.375rem', // 134px - Middle cards top/bottom padding

  // Design-specific spacing (converted from specs)
  logoSpacing: {
    left: '2.5rem',     // 40px - Logo left spacing
    vertical: '1.5rem', // 24px - Logo top/bottom spacing
  },

  timeWidget: {
    right: '2.5rem',    // 40px - Time widget right spacing
    vertical: '1.5rem', // 24px - Time widget top/bottom spacing
  },

  sidebar: {
    top: '2.0625rem',   // 33px - Sidebar content top spacing
    horizontal: '1.5rem', // 24px - Sidebar left/right spacing
    cardGap: '2.0625rem', // 33px - Gap between welcome and wifi cards
  },

  card: {
    padding: '1.5rem',  // 24px - Welcome/wifi card internal padding (averaging 23-26px)
  },

  carousel: {
    vertical: '8.375rem', // 134px - Middle cards container top/bottom padding
  },

  // Legacy spacing for transition
  s: '0.5rem',
  m: '1rem',
  ml: '1.25rem',
  l: '1.5rem',
  xl: '1.75rem',
  xxl: '2rem',
};

// Component-specific spacing tokens
export const componentSpacing = {
  // Header bar
  headerBar: {
    padding: spacing.xl,
    height: '7.9375rem', // 127px
  },

  // Left sidebar  
  leftSidebar: {
    width: '23.3125rem',        // 373px
    padding: {
      top: spacing.sidebar.top,
      horizontal: spacing.sidebar.horizontal,
    },
    cardGap: spacing.sidebar.cardGap,
  },

  // Cards
  welcomeCard: {
    padding: spacing.card.padding,
    marginBottom: spacing.base,
  },

  wifiCard: {
    padding: spacing.card.padding,
  },

  // Service cards carousel
  serviceCarousel: {
    padding: {
      vertical: spacing.carousel.vertical,
      horizontal: 0,
    },
  },

  // Navigation
  bottomNav: {
    gap: spacing.base,
    padding: '0.75rem 1.5rem', // Converted from existing values
    borderRadius: '4.164375rem', // 66.63px radius
    // Dynamic sizing based on icon count - these are base values
    minWidth: '19.3125rem',     // 309px base width
    height: '4.3125rem',        // 69px height
  },
};
